<script lang="ts" setup>
import { v4 as uuid } from 'uuid'
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'

const props = defineProps<{
  module: any
  config: HomePageConfig
  cardClass?: string
  headerClass?: string
  gotoBook: (id: string, firstChapterId?: string) => void
  gotoCollection: (id: string) => void
}>()

function handleSeeAll() {
  props.gotoCollection(props.module.id)
}
</script>

<template>
  <ModuleCard
    :title-text="module.showName"
    :action-text-value="config.texts.seeAll"
    :card-class="cardClass"
    :header-class="headerClass"
    @action="handleSeeAll"
  >
    <div class="mt-14px relative">
      <div class="overflow-x-auto no-scrollbar">
        <div class="flex gap-10px min-w-max pr-16px">
          <div v-for="item in module.resourceList.records" :key="item.id" class="rr-slide-book" @click="gotoBook(item.id, item.firstChapter?.id)">
            <BizBookCover
              :id="uuid()"
              :src="item.contentCoverUrl || ''"
              :extra="{
                module_name: module.showName,
                module_id: module.id,
                module_type: module.columnType,
                author: item.authorInfo.author,
                ...item,
              }"
              class="w-full rounded-10px"
            />
            <p class="mt-9px text-13px font-600 text-n-text-1 line-clamp-2 rr-title">
              {{ item.contentName }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </ModuleCard>
</template>

<style scoped>
.rr-slide-book {
  width: calc((100vw - 68px) / 3);
}

.rr-title {
  width: 100%;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
